import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "../../../../Environments/Environment";
import {
  PartnerPublicRequestContext,
  PartnerPublicRequestSubmitRequest,
  PartnerPublicRequestSubmitResponse,
} from "../Dto/PartnerPublicRequestModel";

@Injectable({ providedIn: "root" })
export class PartnerPublicRequestApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.adminServiceUrl;

  async getContext(token: string): Promise<PartnerPublicRequestContext> {
    const url = new URL(`public/partner-request/${encodeURIComponent(token)}`, `${this.baseUrl}/`);
    return await firstValueFrom(this.http.get<PartnerPublicRequestContext>(url.toString()));
  }

  async submitRequest(token: string, payload: PartnerPublicRequestSubmitRequest): Promise<PartnerPublicRequestSubmitResponse> {
    const url = new URL(`public/partner-request/${encodeURIComponent(token)}`, `${this.baseUrl}/`);
    return await firstValueFrom(this.http.post<PartnerPublicRequestSubmitResponse>(url.toString(), payload));
  }
}
